import {TOP_SECTION} from '../../Module/General';
import {Btn} from '../Landing/index.jsx';
import './sponsors.scss';

function SponsorsHead() {
  return <h1 className="shead">Organizaciones patrocinadoras</h1>;
}

function Sponsor(props) {
  return (
    <div className="Sponsor ">
      <img src={props.srcx} alt="Limbo hacks"></img>
    </div>
  );
}

function SponsorUS() {
  return (
    <div className="joinT sponsorUS">
      <h3>Interesado en patrocinar Co-Afina </h3>
      <a href={TOP_SECTION.DISCORD_LINK}>
        <Btn className="sponsor_btn" type="Patrocínanos" overlay="Escríbenos" />
      </a>{' '}
    </div>
  );
}

export {Sponsor, SponsorUS, SponsorsHead};
